import { i18n } from "@lingui/core";
import { button } from "@warp-ds/css/component-classes";
import WarpElement from "@warp-ds/elements-core";
import "@warp-ds/elements/components/card";
import { css, html } from "lit";
import { trackClickEvent } from "../tracking.js";
import { Brand, Subvertical } from "../../constants.js";
import { TrackingEventMap, eventReference } from "../../models/trackingEvent.js";
import { activateI18n } from "../../utils/i18n.js";

class SellMobilityVehicle extends WarpElement {
    declare brand: Brand;
    declare subvertical: Subvertical;
    declare trackingEventMap: TrackingEventMap;

    static properties = {
        brand: { attribute: true, type: Brand },
        baseurl: { attribute: true, type: String },
        subvertical: { attribute: true, type: Subvertical },
        trackingEventMap: { type: Object },
    };
    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-DhcE9J;
        `,
    ];

    constructor() {
        super();
    }

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
    }
    getSellTitle() {
        switch (this.subvertical) {
            case Subvertical.Car:
                return i18n.t({
                    id: "market-frontpage.sell-box-car",
                    message: "Sell car",
                    comment: "The title above the 'new' ad button on the car market frontpage",
                });
            case Subvertical.Mc:
                return i18n.t({
                    id: "market-frontpage.sell-box-mc",
                    message: "Sell motorcycles",
                    comment: "The title above the 'new' ad button on the motorcycle market frontpage",
                });
            case Subvertical.B2B:
                return i18n.t({
                    id: "market-frontpage.sell-box-b2b",
                    message: "Sell construction and agricultural machinery",
                    comment: "The title above the 'new' ad button on the construction and agricultural machinery market frontpage",
                });
            case Subvertical.Boat:
                return i18n.t({
                    id: "market-frontpage.sell-box-boat",
                    message: "Sell boats",
                    comment: "The title above the 'new' ad button on the boat market frontpage",
                });
        }
    }

    render() {
        const newAdUrl = `/create-item/start`;
        const nettbilUrl = `/nettbil?origin=car_browse`;

        const sellVehicle = this.getSellTitle();

        const newAd = i18n.t({
            id: "market-frontpage.new-ad",
            message: "New ad",
        });

        const nettbil = i18n.t({
            id: "market-frontpage.nettbil",
            message: "Sell using Nettbil",
        });

        return html`<section class="p-16 space-y-16 rounded-8 border" aria-labelledby="selgKjoeretoey">
            <h2 class="h3" id="selgKjoeretoey">${sellVehicle}</h2>
            <a
                data-tracking-id="new-ad"
                @click=${() => trackClickEvent(this.trackingEventMap[eventReference.NEW_AD], newAdUrl)}
                href="${newAdUrl}"
                class="${button.primary} flex mb-16"
            >
                ${newAd}
            </a>
            ${this.brand === Brand.FINN && this.subvertical === Subvertical.Car
                ? html`<a
                      data-tracking-id="nettbil"
                      @click=${() => trackClickEvent(this.trackingEventMap[eventReference.NETTBIL], nettbilUrl)}
                      href="${nettbilUrl}"
                      class="${button.secondary} flex"
                  >
                      ${nettbil}
                  </a>`
                : ""}
        </section>`;
    }
}

customElements.define("mfp-sell-mobility-vehicle", SellMobilityVehicle);
